import { Table, Th, Thead } from 'app/components/Table';
import { Table as TableInstance } from '@tanstack/react-table';
import { Box } from '@chakra-ui/react';
import { ContextMenu, useContextMenu } from 'app/components/ChakraTableList';
import { contextMenuHandler } from 'app/components/Table/ContextMenuButton/utils';
import { getColumnWidth, getTableWidth, getHeader } from './utils';
import { BaseTableType } from './types';
import { STICKY_THEAD_CLASS } from './constants';

interface StickyTableTheadProps<T> {
  table: TableInstance<T>;
  tableKey: string;
  columns: BaseTableType[];
  className?: string;
  gapWidth?: number;
}

export const StickyTableThead = <T extends {}>({
  table,
  tableKey,
  columns,
  className = STICKY_THEAD_CLASS,
  gapWidth,
}: StickyTableTheadProps<T>) => {
  const contextMenuProps = useContextMenu();
  const options = [
    {
      title: 'Reset col. widths',
      value: 'RESET_COL_WIDTHS',
      onClick: table.resetColumnSizing,
    },
  ];

  return (
    <Box
      sx={{
        zIndex: 'sticky',
        position: 'sticky',
        top: 0,
      }}
    >
      <Box
        overflowX="auto"
        className={className}
        sx={{
          '::-webkit-scrollbar': {
            height: 0,
          },
        }}
      >
        <Table w={getTableWidth(table, gapWidth)}>
          <ContextMenu contextMenuProps={contextMenuProps} />
          <Thead sx={{ bg: 'M.10' }}>
            {columns.map((c, i) => {
              const header = getHeader(table, i);
              return (
                <Th
                  tableKey={tableKey}
                  onContextMenu={(e) =>
                    contextMenuHandler(e, contextMenuProps, options)
                  }
                  key={c.accessorKey}
                  isAvatar={c.isAvatar}
                  isOptions={c.isOptions}
                  sortColumnProps={
                    header.column.getIsResizing()
                      ? undefined
                      : c?.sortColumnProps
                  }
                  position="relative"
                  width={`${getColumnWidth(header, gapWidth)}px`}
                  header={c.enableResizing ? header : undefined}
                  className={c.accessorKey === 'gap' ? 'gap' : ''}
                  color="textSubdued"
                  sx={c?.sx}
                >
                  <Box>{c.header}</Box>
                </Th>
              );
            })}
          </Thead>
        </Table>
      </Box>
    </Box>
  );
};
